export default {
  methods: {
    showPopup(this: any, popupComponentName: string) {
      // open popup by name of component
      this.$store.commit('showPopup', popupComponentName);
    },
    hidePopup(this: any, ) {
      this.$store.commit('hidePopup');
    }
  }
};
